import Contact from 'modules/contact/Contact';
import Help from 'modules/help/Help';
import Homepage from 'modules/homepage/Homepage';
import Search from 'modules/search/Search';
import NotFound from 'components/not-found/NotFound';

import { AppRoute } from './AppRouter';

export enum AppRoutePath {
	HOMEPAGE = '/home',
	SEARCH = '/search',
	SEARCH_PEOPLE = '/search/people',
	SEARCH_OPERATES = '/search/operates',
	HELP = '/help',
	CONTACT = '/contact',
	DEFAULT = '/',
	NOT_FOUND = '*',
}

const AppRoutes: AppRoute[] = [
	{
		path: [AppRoutePath.HOMEPAGE, AppRoutePath.DEFAULT],
		component: Homepage,
	},
	{
		path: [
			AppRoutePath.SEARCH,
			AppRoutePath.SEARCH_PEOPLE,
			AppRoutePath.SEARCH_OPERATES,
		],
		component: Search,
	},
	{
		path: AppRoutePath.HELP,
		component: Help,
	},
	{
		path: AppRoutePath.CONTACT,
		component: Contact,
	},
	{
		path: AppRoutePath.NOT_FOUND,
		component: NotFound,
	},
];

export default AppRoutes;
